import { InformationTooltip, Label as UIKitLabel } from '@cian/ui-kit';
import { TColors } from '@cian/ui-kit-design-tokens/colors';
import * as React from 'react';
import * as styles from './Label.css';

import { ELabelType, ICardLabel } from '../../types/newbuilding';
import { IconActionChevronRight12 } from '@cian/ui-kit-design-tokens/icons';

interface ILabelProps {
  label: ICardLabel;
}

const discountMortgageIcon = require('../../assets/discount-mortgage.svg');
const bookingIcon = require('./assets/click.svg');

// oxlint-disable-next-line typescript/no-explicit-any
const LABEL_TO_ICON: Record<ELabelType, React.ReactElement<any, any> | undefined> = {
  [ELabelType.PromoExclusive]: undefined,
  [ELabelType.Promo]: undefined,
  [ELabelType.PremiumPromo]: undefined,
  [ELabelType.FrozenConstruction]: undefined,
  [ELabelType.DiscountMortgage]: <img src={discountMortgageIcon} alt="" />,
  [ELabelType.NewbuildingBrokerBooking]: <img src={bookingIcon} alt="" />,
  [ELabelType.SalesLeader]: undefined,
  [ELabelType.SalesStart]: undefined,
  [ELabelType.NewHouse]: undefined,
};

const LABEL_TO_BACKGROUND_COLOR: Record<ELabelType, TColors> = {
  [ELabelType.PromoExclusive]: 'linear-gradient(90deg, black 0%, #0766fc 100%)' as TColors,
  [ELabelType.DiscountMortgage]: 'var(--decorative-lavender-transparent)' as TColors,
  [ELabelType.PremiumPromo]: 'surface-positive-default',
  [ELabelType.Promo]: 'surface-positive-default',
  [ELabelType.NewbuildingBrokerBooking]: 'accent-ghost-secondary',
  [ELabelType.SalesLeader]: 'accent-ghost-secondary',
  [ELabelType.SalesStart]: 'accent-ghost-secondary',
  [ELabelType.NewHouse]: 'accent-ghost-secondary',
  [ELabelType.FrozenConstruction]: 'accent-negative-secondary',
};

const LABEL_TO_COLOR: Record<ELabelType, TColors> = {
  [ELabelType.PromoExclusive]: 'theme-white',
  [ELabelType.DiscountMortgage]: 'decorative-purple',
  [ELabelType.PremiumPromo]: 'accent-positive-primary',
  [ELabelType.Promo]: 'accent-positive-primary',
  [ELabelType.NewbuildingBrokerBooking]: 'text-primary-default',
  [ELabelType.SalesLeader]: 'text-primary-default',
  [ELabelType.SalesStart]: 'text-primary-default',
  [ELabelType.NewHouse]: 'text-primary-default',
  [ELabelType.FrozenConstruction]: 'accent-negative-primary',
};

export const Label: React.FC<ILabelProps> = ({ label }) => {
  /* istanbul ignore next */
  const background = LABEL_TO_BACKGROUND_COLOR[label.type] || 'accent-ghost-secondary';
  /* istanbul ignore next */
  const color = LABEL_TO_COLOR[label.type] || 'text-primary-default';
  const icon = LABEL_TO_ICON[label.type];

  const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);

  const handleLabelClick = React.useCallback(() => {
    setIsTooltipOpen(true);
  }, []);

  const handleTooltipClose = React.useCallback(() => {
    setIsTooltipOpen(false);
  }, []);

  if (label.description) {
    return (
      <InformationTooltip
        content={<div className={styles['tooltip-content']}>{label.description}</div>}
        open={isTooltipOpen}
        onClose={handleTooltipClose}
        placement="bottom-start"
      >
        <UIKitLabel
          icon={icon}
          background={background}
          color={color}
          borderColor="background-primary"
          borderWidth={1}
          borderStyle="solid"
          onClick={handleLabelClick}
          rightIcon={<IconActionChevronRight12 color="current_color" />}
        >
          {label.text}
        </UIKitLabel>
      </InformationTooltip>
    );
  }

  return (
    <UIKitLabel
      icon={icon}
      background={background}
      color={color}
      borderColor="background-primary"
      borderWidth={1}
      borderStyle="solid"
    >
      {label.text}
    </UIKitLabel>
  );
};
